import React, { useEffect, useRef } from "react";
import { t } from "ttag";

import {
    LatLng,
    LocationID,
    LocationProximity,
    isoLocationID,
} from "../../models";
import { LocationList } from "./LocationList";
import { UpdateLocationForm } from "./UpdateLocationForm";

import styles from "./index.module.scss";

interface LocatorMapProps {
    locations: LocationProximity[];
    focusedLocationID: LocationID | null;
    setFocusedLocationID: (id: LocationID | null) => void;
    error: string;
    onLocationSearch: (
        point: LatLng | null,
        bounds?: google.maps.LatLngBounds,
    ) => void;
    onError: (error: string) => void;
    mapType: string;
    mapSlot: React.ReactNode;
    children?: React.ReactNode;
}

export const LocatorMap = (props: LocatorMapProps) => {
    const column1Ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!column1Ref.current || !props.focusedLocationID) return;
        const item = column1Ref.current.querySelector(
            `[data-id="${isoLocationID.get(props.focusedLocationID)}"]`,
        );
        if (item instanceof HTMLElement) {
            item.scrollIntoView({ behavior: "smooth" });
        }
    }, [props.focusedLocationID]);

    return (
        <div className={styles.container}>
            <div className={styles.column1}>
                <div className={styles.column1Inner} ref={column1Ref}>
                    <UpdateLocationForm
                        onLocationUpdate={props.onLocationSearch}
                        onError={props.onError}
                        mapType={props.mapType}
                    />
                    {props.error !== "" && (
                        <p className={styles.locationError}>{props.error}</p>
                    )}
                    {props.locations.length === 0 && (
                        <p className={styles.locationError}>
                            {t`Enter a valid city, state, or ZIP code.`}
                        </p>
                    )}
                    <LocationList
                        locations={props.locations}
                        onSelect={props.setFocusedLocationID}
                    />
                </div>
                {props.children}
            </div>
            <div className={styles.column2}>{props.mapSlot}</div>
        </div>
    );
};
